var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Treatment "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M8.21053 5.6047H9.86842M11.5263 5.6047H9.86842M9.86842 5.6047V3.70996H14.3684V12.2363M14.3684 12.2363H17.5277C17.6279 12.2363 17.724 12.2761 17.7948 12.3469L20.2895 14.8415C20.6819 15.234 20.6819 15.8702 20.2895 16.2626V16.2626V16.2626C19.8971 16.655 19.2608 16.655 18.8684 16.2626L17.3635 14.7576C17.2655 14.6597 17.1327 14.6047 16.9942 14.6047H9.86842M14.3684 12.2363H8.88538C8.75657 12.2363 8.63304 12.1851 8.54197 12.094L5.13158 8.68364C4.73917 8.29123 4.10294 8.29123 3.71053 8.68364V8.68364V8.68364C3.31811 9.07606 3.31811 9.71229 3.71053 10.1047L7.87404 14.2682C8.08949 14.4837 8.3817 14.6047 8.68638 14.6047H9.86842M14.3684 17.4468V20.2889M9.86842 14.6047V20.2889M15.7895 20.2889H8.21053",
    stroke: "#6E6E73",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.21d00bbb4a9d598166b54afa34d7faa9.svg";
export { ForwardRef as ReactComponent };